import { RELEASE_TYPE, PAGE } from "@/features/releaseNote/enum";

export default {
  releaseNote: {
    viewTitle: "Release Note",
    tabTitle: "ReleaseNote",
    releaseForNotificationBar: "最新バージョンがリリースされました。",
    // NOTE: HOMEの通知バーに表示するバグがある場合、以下にメッセージを記載
    bugNotification: "",
    contents: [
      // NOTE: 最新が一番上になるように、バージョンは降順にする
      {
        releaseYear: "2026",
        releaseMonth: "04",
        releaseDay: "08",
        version: "バージョン5.2.0",
        items: [
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "同一のAdUnit内に同一名称のAdUnitGroupが複数存在する場合、実績数値が重複される形で表示される不具合を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "10",
        releaseDay: "16",
        version: "バージョン5.1.0",
        items: [
          {
            page: PAGE.ADUNIT_GROUP.text,
            sentences: [
              {
                text: "可視範囲外の広告枠を含む広告枠グループにアクセスできてしまう不具合を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "10",
        releaseDay: "10",
        version: "バージョン5.0.0",
        items: [
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "画面右上の通貨選択ボタンから、日本円と台湾ドルでの通貨の切り替えができるようになりました。",
                type: RELEASE_TYPE.FEATURE,
              },
            ],
          },
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "画面右下のウィジェットから繁体字への翻訳ができるようになりました。",
                type: RELEASE_TYPE.FEATURE,
              },
            ],
          },
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "日本円に加え、台湾ドルでもレポートをダウンロードできるようになりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "06",
        releaseDay: "01",
        version: "バージョン4.8.4",
        items: [
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "AGENCY MEMBER, CLIENT MEMBER ユーザでの保存レポート名の可視範囲を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
          {
            page: PAGE.SETTING.text,
            sentences: [
              {
                text: "AGENCY MEMBER, CLIENT MEMBER ユーザでのアカウント名の可視範囲を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "04",
        releaseDay: "01",
        version: "バージョン4.8.2",
        items: [
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "細かな不具合の修正を行いました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "03",
        releaseDay: "22",
        version: "バージョン4.8.0",
        items: [
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "Prebid Analytics レポートのメトリクスで「Average Auction Time」を選択した際、指標の値が0以上のデータのみで計算され、取得されるようになりました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
              {
                text: "細かな不具合の修正を行いました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "03",
        releaseDay: "09",
        version: "バージョン4.7.0",
        items: [
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "データ読み込み中でも Analytics/Scraping のタブ切り替えができるようになりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
              {
                text: "クライアント、パブリッシャーの選択項目を1個ずつ削除できるようになりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.CORE_WEB_VITALS.text,
            sentences: [
              {
                text: "ドメイン選択ボタンでのパブリッシャー変更時の不具合を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
              {
                text: "ドメイン選択ボタンで、現在データを表示しているドメインが表示されるようになりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
              {
                text: "CLIENT アカウント利用時のドメイン選択ボタンの表示を微修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
              {
                text: "登録ドメイン一覧ページにて、パブリッシャーの選択項目を1個ずつ削除できるようになりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "02",
        releaseDay: "27",
        version: "バージョン4.6.1",
        items: [
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "MEMBER アカウントを利用した際の publisher 絞り込み条件の不具合を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2023",
        releaseMonth: "02",
        releaseDay: "02",
        version: "バージョン4.6.0",
        items: [
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "Filter の期間選択にて「日付指定」を選択できるようになりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.CORE_WEB_VITALS.text,
            sentences: [
              {
                text: "登録ドメイン一覧画面において、ドメイン検索の不具合を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
          {
            page: PAGE.SETTING.text,
            sentences: [
              {
                text: "ユーザ検索の不具合を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2022",
        releaseMonth: "12",
        releaseDay: "22",
        version: "バージョン4.5.0",
        items: [
          {
            page: PAGE.ADUNIT_GROUP.text,
            sentences: [
              {
                text: "枠グループ削除確認メッセージのデザインを微修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2022",
        releaseMonth: "11",
        releaseDay: "24",
        version: "バージョン4.3.0",
        items: [
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "スクレイピングデータの取得期間を修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "レポート一覧にソート機能を追加しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.ADUNIT_GROUP.text,
            sentences: [
              {
                text: "枠グループ一覧にソート機能を追加しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.CORE_WEB_VITALS.text,
            sentences: [
              {
                text: "登録ドメイン一覧ページの UI を微修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
              {
                text: "ドメイン一覧にパブリッシャー名、作成日でのソート機能を追加しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2022",
        releaseMonth: "11",
        releaseDay: "10",
        version: "バージョン4.2.0",
        items: [
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "オークションタイムデータの取得に失敗した時のエラーメッセージを修正しました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
            ],
          },
          {
            page: PAGE.CORE_WEB_VITALS.text,
            sentences: [
              {
                text: "ユーザー側で、CWVのドメインを登録・編集・削除できるページを追加しました。",
                type: RELEASE_TYPE.FEATURE,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2022",
        releaseMonth: "10",
        releaseDay: "11",
        version: "バージョン4.1.0",
        items: [
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "リリース時に表示される通知バーのUIを微修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "Prebid Analytics レポートのメトリクスで「Average Auction Time」を選択した際、指標の値が20000以下のデータのみで計算され、取得されるようになりました。",
                type: RELEASE_TYPE.BUG_FIX,
              },
              {
                text: "期間選択の日付指定を選択した際のカレンダーの挙動を修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
              {
                text: "レポートをダウンロードした際のダイアログ表示を変更しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
              {
                text: "フィルタを選択した際の挙動を修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.ADUNIT_GROUP.text,
            sentences: [
              { text: "一覧ページのUIを微修正しました。", type: RELEASE_TYPE.ENHANCEMENT },
              {
                text: "パブリッシャー検索をした際の挙動を修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.CORE_WEB_VITALS.text,
            sentences: [
              {
                text: "日別フィールドデータグラフの期間を変更した際の挙動を修正しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
        ],
        detailLink: "",
      },
      {
        releaseYear: "2022",
        releaseMonth: "09",
        releaseDay: "26",
        version: "バージョン4.0.0",
        items: [
          {
            page: PAGE.HOME.text,
            sentences: [
              {
                text: "Dashboard で Scraping データが表示できるようになりました。",
                type: RELEASE_TYPE.FEATURE,
              },
              { text: "着地予想のデザインを一部変更しました。", type: RELEASE_TYPE.ENHANCEMENT },
              {
                text: "データの取得期間が表示されるようになりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.ANALYTICS.text,
            sentences: [
              {
                text: "Prebid Analytics レポートの最大取得可能期間が31日になりました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.CORE_WEB_VITALS.text,
            sentences: [
              {
                text: "日別フィールドデータグラフにFCPの指標を追加しました。",
                type: RELEASE_TYPE.ENHANCEMENT,
              },
            ],
          },
          {
            page: PAGE.RELEASE_NOTE.text,
            sentences: [
              {
                text: "リリース時に、変更点を記載するページを作成しました。",
                type: RELEASE_TYPE.FEATURE,
              },
            ],
          },
        ],
        detailLink: "",
      },
    ],
  },
};
